import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import { AppletNotificationLoginSubscriptionContainerModel } from '../../../../../models/aggregates/applet/applet-notification-login-subscription.model';
import { ApiResponseModel, ApiVisa } from '../shared';

@Injectable({providedIn: 'root'})
export class AppletLoginNotiicationSubscriptionService extends BaseApiTemplateService<AppletNotificationLoginSubscriptionContainerModel>{
    constructor(http: HttpClient) {
    super();
    this.apiUrl =
        Core2Config.DOMAIN_URL +
        Core2Config.TENANT_DOMAIN_URL_PREFIX + 
        'notification/login-subject-subscriptions/backoffice-ep';
    this.httpClient = http;
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + 
    'notification/login-subject-subscriptions/backoffice-ep';
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 
    'notification/login-subject-subscriptions/login-ep'
    }

    postTopicSubscription(dtoObject: AppletNotificationLoginSubscriptionContainerModel, websiteCode: string, apiVisa: ApiVisa) {
        const domain = (apiVisa.api_domain_url == null || apiVisa.api_domain_url == '') ?
        Core2Config.DOMAIN_URL :
        apiVisa.api_domain_url;

        const path = domain + Core2Config.TENANT_DOMAIN_URL_PREFIX + 
        'notification/login-subject-subscriptions/publish/backoffice-ep';

        apiVisa.applet_code = apiVisa.applet_code ? apiVisa.applet_code : 'none';
        apiVisa.tenantCode = apiVisa.tenantCode ? apiVisa.tenantCode: '';

        const httpOptions = {
        headers: new HttpHeaders({
            authorization: apiVisa.jwt_secret,
            tenantCode: apiVisa.tenantCode,
            appId: apiVisa.applet_code,
            websiteCode: websiteCode
        })
        };

        return this.httpClient.post<ApiResponseModel<AppletNotificationLoginSubscriptionContainerModel>>(
            path,
            dtoObject,
            httpOptions
        );
    }
    
}